<template>
  <div class="hello">
    <div  class="page">
      <div >
        <div class="nav_box"></div>
        <div class="nav">
          <div class="back"><img
              src="data:image/jpeg;base64,/9j/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAgEBAgICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//dAAQAA//uAA5BZG9iZQBkwAAAAAH/wAARCAAhABYDABEAAREBAhEB/8QAfQAAAwADAAAAAAAAAAAAAAAABwgKAAUJAQADAQEAAAAAAAAAAAAAAAAABgcIBBAAAQQDAAICAQUAAAAAAAAAAwIEBQYBBwgAExESFQkjN3e2EQACAgEDBAECBAcAAAAAAAABAgMEBQYHEQASEyEiMTIUMzZ1CBUWI1KztP/aAAwDAAABEQIRAD8Av48OjpVOjOrapok0HSYSClds77vaVi1poulLEa2WU2fYjExNuFYK1plIYrEpbyYf4Q3CERVISXIlpTRtC7cZLWKzZa3NHjdGU/drIT8iGIf4Rj0Z7DcgJBHyzMVBKhgTKNx92MToN4MHRgly+v74IpYusQbEx9/3JT7WtWUgmSxLwiqrlQ5VgBFrfj2xbBmnm5O1LEPZ21p6LLGQ2uq1KzkPp3Slbeu2cgaq0qNYv2bmdmXB2APyU09UQ7tQUDR+2j2FZs9ufRwlRdLbUQHH6chkDvZlSN7t+VQyiad2VhGgDN4oIwFQMSfbdqqGmtnclqG6+s97LIymrLERSOnDJLHjsbCzK5grIrK0shKJ5rMhLSFQo+K9z//Qr32z1Tdr5epjnTi+LiL3teLJhhsvb0whbrTXPYTZUIxLFIgSQFv2GPCVYZ19pkuUnQrLv4SA4fLTprbrE4bDxa53Vklp6bkHdVpJ6vZIj2PEp4MNY+u+y/HKkeP26P1nzV262cz+dm242Vihv6tiPZdyEnLY7EA+iZnHIsXB78dSPu4cEzekkToxc58r0nn0M5YVScvsnc17Wh5tHeF3Uh9erxI59alN8HUoyK5VGSxIQxh2aktGoRDTn2kR7VK+udxctrVoaQjioaVpjtqUK/xr119++PXlmbkmSd+Xdix+KntDltxtTg9vUnyJlmyetL5DXsnZ4a1af1659iGBSAIq8ZEcaqoPcw7yz/k+6qPX/9GsWe0HtLjWxWDavHEGq66hsUu4s23OQiOUt0reuECTLXfn6TNheK/a8N26VFgC/ZjIjR6m+ELS0EO/U9Z6d3Towac3Sm/CamgiEVLNAc/Ec9lfJIPzIeSQLI4kiJ7n5UyM2Y7+gNVbMZGxqvZmD8bo+zMZ8hp8txyx48lnEufyZ+AC1RuYpgOyPtYRIrl6K3/q/oylDvGr578kzA5JF2GCkG64u20qxNflEhVrpXHOcP6/YI4yVIIEuPovGPYJZBKQRUr1hovUOhsscRqGHxylQ8cinvhniP2zQSj4yxsPYYex9GCsCos+hNwdLbj4QZ3S1jywqxSaJwY7FaZfvgswt84ZkPIKt6PHchZCGJo8VenXr//Sv48OjpIN68nSkpdSdDcy2hlpnpZo2GKSkyNSm1vumLafCh1DdVZZ/XEw1OlHqBMATiVj/lK0KJkQUjrej9ya9fEjRGv675XQLMSqAgWqLn6zUJW+wj6tAx8MnsEL3OWhuu9pbVrNncTbC0mF3NRQHcqTTySL9K+SgX8xT9qWFHnh9MpbsQLs9F9i1i/PpvW25IhPP3QtFaBPe9WXiVZNWzhisyGgblryzuCN4q8UOUcqxgDxqtSwrVgZk4+wyF59X7XZDDQw57S0v860TcYivbroxIbjkwWYgC9ewg+5HHDAcqTwyr1aE3kxeoJ59M6zh/p7cSggNqjakVQVJ7RZqTkiO1VdvtkQkqSFcDlWf//Tv48OjrPDo65A/qIfznpD+p9sf7DVnmndj/0hl/3Kn/ot9Y9/iL/XWD/ab/8A0Uev/9k="
              alt="" v-on:click="back()">返回</div>
          <div class="nav_title">课程列表</div> <a href="#/en" class="lang_icn"><img src="/static/images/icn-03.png"
              class="icn"></a>
        </div>
      </div>
      <div  class="title">
        <div data-v-b5908326="" class="list_title">{{ parentsData.Name }}</div>
        <div data-v-b5908326="" class="list_title">共{{ parentsData.Del }}课程</div>
      </div>
      <div v-for="(item, index) in listData" v-on:click="jumpSelf(item.ID)"  class="list_item">
        <a  href="javascript:;" class="">
          <div  class="pimg"><img  alt=""
            :data-src="baseUrl + item.Pic"
            :src="baseUrl + item.Pic" lazy="loaded"></div>
          <div >{{ item.Name }}</div>
          <p >共{{ item.Del }}个造型</p>
        </a>
      </div>
    
      <footer  class="footer">
        @3D拼装图纸
      </footer>
      <div  id="page-spinner" class="page-spinner" style="display: none;">
        <div class="vue-simple-spinner"
          style="margin: 0px auto; border-radius: 100%; border-width: 3px; border-style: solid; border-color: rgb(33, 150, 243) rgb(238, 238, 238) rgb(238, 238, 238); border-image: initial; width: 32px; height: 32px; animation: 0.8s linear 0s infinite normal none running vue-simple-spinner-spin;">
        </div>
        <div id="spinnertext" class="vue-simple-spinner-text"
          style="margin-top: 4px; color: rgb(255, 255, 255); font-size: 14px; text-align: center;">正在加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
let query
export default {
  name: 'index',
  created() {
    query = this.$route.query
  },
  mounted() {
    let that = this;
    this.$set(this.$data, 'isGetlist', true)
    this.$http({
      method: "get",
      url: './static/getMassage/Handler/getCategoryDetail/List/' + query.id + '.json?UID=1&action=getCategoryList&id=' + query.id
    }).then(res => {
      if (res.status == 200) {
        that.$set(that.$data, 'parentsData', res.data.data.list[0]);
        that.$set(that.$data, 'listData', res.data.data.plist);
      }
    })

  },
  data() {
    return {
      isGetlist: false,
      baseUrl: 'http://aly.haominapp.com/',
      listData: {},
      parentsData: {},
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    jumpSelf(Id) {
      this.$router.push({ name: 'modelList', query: { id: Id } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/lessonList.vue